import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cloneDeep, isEmpty } from "lodash";
import Loader from "./loader";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "NotificationsPage",
  components: {
    Loader
  },
  props: {
    notificationPreferences: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    hideAllWeb: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      required: true,
      validator(value) {
        return value === "client" || value === "broker";
      }
    }
  },
  data() {
    return {
      notifications: cloneDeep(this.notificationPreferences),
      updatedNotifications: this.notificationPreferences
    };
  },
  computed: {
    titleTextMap() {
      return {
        applications: this.$t("settings.notificationsTab.applicationNotifications"),
        board: this.$t("settings.notificationsTab.clientProfileAndBoardsNotifications"),
        reports: this.$t("settings.notificationsTab.reportsNotifications"),
        documents: this.$t("settings.notificationsTab.documentsNotifications"),
        system: this.$t("settings.notificationsTab.systemNotifications")
      };
    },
    actionsTextMap() {
      return {
        newLead: {
          label: this.$t("settings.notificationsTab.notificationsText.newLead.label"),
          description: this.$t("settings.notificationsTab.notificationsText.newLead.description")
        },
        clientRegistration: {
          label: this.$t("settings.notificationsTab.notificationsText.clientRegistration.label"),
          description: this.$t("settings.notificationsTab.notificationsText.clientRegistration.description")
        },
        applicationSubmitted: {
          label: this.$t("settings.notificationsTab.notificationsText.applicationSubmitted.label"),
          description: this.$t("settings.notificationsTab.notificationsText.applicationSubmitted.description")
        },
        closeApplicationReminder: {
          label: this.$t("settings.notificationsTab.notificationsText.closeApplicationReminder.label"),
          description: this.$t("settings.notificationsTab.notificationsText.closeApplicationReminder.description")
        },
        clientProfileChange: {
          label: this.$t("settings.notificationsTab.notificationsText.clientProfileChange.label"),
          description: this.$t("settings.notificationsTab.notificationsText.clientProfileChange.description")
        },
        clientProfileTransferred: {
          label: this.$t("settings.notificationsTab.notificationsText.clientProfileTransferred.label"),
          description: this.$t("settings.notificationsTab.notificationsText.clientProfileTransferred.description")
        },
        clientProfileNoteAdded: {
          label: this.$t("settings.notificationsTab.notificationsText.clientProfileNoteAdded.label"),
          description: this.$t("settings.notificationsTab.notificationsText.clientProfileNoteAdded.description")
        },
        followUpAssigned: {
          label: this.$t("settings.notificationsTab.notificationsText.followUpAssigned.label"),
          description: this.$t("settings.notificationsTab.notificationsText.followUpAssigned.description")
        },
        scheduledFollowUp: {
          label: this.$t("settings.notificationsTab.notificationsText.scheduledFollowUp.label"),
          description: this.$t("settings.notificationsTab.notificationsText.scheduledFollowUp.description")
        },
        collaborationChange: {
          label: this.$t("settings.notificationsTab.notificationsText.collaborationChange.label"),
          description: this.$t("settings.notificationsTab.notificationsText.collaborationChange.description")
        },
        newComment: {
          label: this.$t("settings.notificationsTab.notificationsText.newComment.label"),
          description: this.$t("settings.notificationsTab.notificationsText.newComment.description")
        },
        requestedDocuments: {
          label: this.$t("settings.notificationsTab.notificationsText.requestedDocuments.label"),
          description: this.$t("settings.notificationsTab.notificationsText.requestedDocuments.description")
        },
        markedDocumentComplete: {
          label: this.$t("settings.notificationsTab.notificationsText.markedDocumentComplete.label"),
          description: this.$t("settings.notificationsTab.notificationsText.markedDocumentComplete.description")
        },
        markedDocumentOutstanding: {
          label: this.$t("settings.notificationsTab.notificationsText.markedDocumentOutstanding.label"),
          description: this.$t("settings.notificationsTab.notificationsText.markedDocumentOutstanding.description")
        },
        uploadedDocument: {
          label: this.$t("settings.notificationsTab.notificationsText.uploadedDocument.label"),
          description: this.$t("settings.notificationsTab.notificationsText.uploadedDocument.description")
        },
        bankStatementsRequestCompleted: {
          label: this.$t("settings.notificationsTab.notificationsText.bankStatementsRequestCompleted.label"),
          description: this.$t("settings.notificationsTab.notificationsText.bankStatementsRequestCompleted.description")
        },
        promotional: {
          label: this.$t("settings.notificationsTab.notificationsText.promotional.label"),
          description: this.source === "broker" ? this.$t("settings.notificationsTab.notificationsText.promotional.descriptionBroker") : this.$t("settings.notificationsTab.notificationsText.promotional.descriptionAgent")
        },
        releaseNotes: {
          label: this.$t("settings.notificationsTab.notificationsText.releaseNotes.label"),
          description: this.$t("settings.notificationsTab.notificationsText.releaseNotes.description")
        },
        reportGeneration: {
          label: this.$t("settings.notificationsTab.notificationsText.reportGeneration.label"),
          description: this.$t("settings.notificationsTab.notificationsText.reportGeneration.description")
        }
      };
    },
    sectionVisibilityMap() {
      return {
        applications: {
          broker: true,
          client: false
        },
        board: {
          broker: true,
          client: false
        },
        documents: {
          broker: true,
          client: true
        },
        reports: {
          broker: true,
          client: false
        },
        system: {
          broker: true,
          client: true
        }
      };
    },
    actionHideMap() {
      return {
        newComment: {
          client: true
        },
        requestedDocuments: {
          broker: true
        },
        markedDocumentComplete: {
          broker: true
        },
        markedDocumentOutstanding: {
          broker: true
        },
        uploadedDocument: {
          client: true
        },
        clientProfileChange: {
          broker: true
        },
        clientProfileNoteAdded: {
          broker: true
        },
        releaseNotes: {
          client: true
        }
      };
    }
  },
  watch: {
    notificationPreferences: {
      immediate: true,
      deep: true,
      handler(value) {
        if (isEmpty(value)) {
          return;
        }
        const notifications = cloneDeep(value);
        for (const section in value) {
          for (const key in value[section]) {
            var _this$actionHideMap$k;
            if ((_this$actionHideMap$k = this.actionHideMap[key]) != null && _this$actionHideMap$k[this.source]) {
              delete notifications[section][key];
            }
          }
        }
        this.notifications = notifications;
      }
    }
  },
  methods: {
    async handleSubmit() {
      for (const section in this.notifications) {
        for (const key in this.notifications[section]) {
          this.updatedNotifications[section][key] = this.notifications[section][key];
        }
      }
      this.$emit("submit", this.updatedNotifications);
    },
    getSectionTitle(key) {
      return this.titleTextMap[key];
    },
    getActionTitle(key) {
      return this.actionsTextMap[key].label;
    },
    getActionDescription(key) {
      return this.actionsTextMap[key].description;
    },
    getInputName(key, type) {
      return `${key}-${type}`;
    },
    markAllInside({
      currentTarget
    }, key, type) {
      const checked = currentTarget.checked;
      const section = this.notifications[key];
      for (const action in section) {
        if (action == "releaseNotes" && type == "email" && checked == false) {
          continue;
        }
        section[action] = _objectSpread(_objectSpread({}, section[action]), {}, {
          [type]: checked
        });
      }
    },
    shouldBeMarkedFor(key, type) {
      const section = this.notifications[key];
      for (const action in section) {
        if (section[action][type] === false || section[action][type] === "false") return false;
      }
      return true;
    },
    handleFormChange() {
      this.$emit("allow-save", true);
    }
  }
});